export default {
  '3fc98ff96c77fb58e862912d76e0ac75':
    'Address acquisition failed. Please manually select the province, city or district',
  '3465345a5f20c9a2086c351800c2d264': 'The order address has been modified successfully',
  '762d7101cd72237f2109c1f950e7d669': 'The order address modification failed',
  f98aeeb32a5a904d1e14561a20fc2566: 'Modify the address',
  e7a990e66eb5601aecc8cc7033b7f96c: 'Add new address',
  f6cdabf801b598f87cc608a3edbd5ecb: 'Save',
  '7ac104292a4e5b51e139fde0e8468987': 'My Address Page - Default Address Switch',
  '284445c667bcf99437898e15c99a59c1': 'My Address page _ Save and use',
  '07cac475bf9d525a4782d4ee8136fab8': 'The address has been saved successfully',
  '988b0e88ff6676c8a04b6908f6efe410': 'The query failed.',
  b6df6577228146abbc58ec803bd5cdb2: 'Failed to select the address',
  '124e146cbd95dc538221ed4172223f56': 'There was an error in loading the map',
  abd2cc4565019da6af8b6584fa42c6b9: 'Name',
  '0ce21a82752147cfba0e3654b13f5453': 'Id card',
  '43953dd11cc7109f6279d56bc483cd18': 'Save and use'
};
